import {Invoice, InvoiceEntry} from 'app/models/Invoice';
import axios, {AxiosResponse} from 'axios';

const API_URL = process.env.REACT_APP_FINANCE_API_URL;

export const getInvoices = (
  params: string
): Promise<{result: Invoice[]; resultCount: number}> => {
  return axios
    .get(`${API_URL}/invoices?${params}`)
    .then((d: AxiosResponse<{result: Invoice[]; resultCount: number}>) => {
      return d.data;
    })
    .catch((e) => {
      throw e;
    })
    .finally(() => {
      return [];
    });
};

export const getInvoiceByUid = async (
  uid: string
): Promise<Invoice & {invoice_entries: InvoiceEntry[]}> => {
  return axios
    .get(`${API_URL}/invoices/${uid}`)
    .then((d: AxiosResponse<Invoice & {invoice_entries: InvoiceEntry[]}>) => {
      return d.data;
    })
    .catch((e) => {
      throw e;
    })
    .finally(() => {
      return [];
    });
};
